import ProductCard from "../product-card/product-card.component";
import AnimationPage from "../smallcomponents/animation.component";

import {
  CategoryPreviewContainer,
  Title,
  Preview,
} from "./category-preview.styles";

const CategoryPreview = ({ title, products }) => {
  return (
    <AnimationPage>
      <CategoryPreviewContainer>
        <h2>
          <Title to={title}> {title.toUpperCase()}</Title>
        </h2>
        <Preview>
          {products
            .filter((_, idx) => idx < 6)
            .map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
        </Preview>
      </CategoryPreviewContainer>
    </AnimationPage>
  );
};
//<p>Most trending </p>
export default CategoryPreview;
